import * as types from '../constants/actionTypes'

export const hideModal = () => ({
  type: types.HideModal,
})

export const showAnalyticsModal = () => ({
  type: types.ShowAnalyticsModal,
})
